// Ejemplo simplificado del servicio de directorios
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Directory } from './directory';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Responses } from 'src/app/models/interfaces/responses';
import { map } from 'rxjs/operators';
import { UntypedFormGroup } from '@angular/forms';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root'
})
export class DirectoryService {
  private domain = environment?.baseApiUrl;

  constructor(private http: HttpClient) { }

  getDirectories(): Observable<Responses> {
    return this.http.get<Responses>(this.domain + "extensions/images/directorys");
  }
  buildDirectoryTree(directoryData: Directory[]): Directory[] {
    // Primero, crea un mapa para acceder fácilmente a cada directorio por su ID.
    const directoryMap = new Map<number, Directory>();
    directoryData.forEach(dir => {
      directoryMap.set(Number(dir.id), { ...dir, subdirectories: [] });
    });

    // Construye la estructura del árbol usando el mapa para encontrar y asignar subdirectorios.
    const tree: Directory[] = [];
    directoryData.forEach(dir => {
      if (dir?.directory_id > 0) {
        const parentDir = directoryMap.get(Number(dir.directory_id));
        if (parentDir) {
          // Agrega el directorio actual como un subdirectorio de su padre.
          parentDir.subdirectories.push(directoryMap.get(Number(dir.id)));
        }
      } else {
        // Si no tiene directory_id, es un directorio raíz.
        tree.push(directoryMap.get(Number(dir.id)));
      }
    });

    // Retorna solo los directorios raíz, que ahora incluyen subdirectorios.
    return tree.filter(dir => !dir.directory_id);
  }


  addDirectory(form: UntypedFormGroup): Observable<Responses> {
    const body = new HttpParams().appendAll(form.value);
    return this.http.post<Responses>(
      this.domain + 'extensions/images/dcreate/',
      body,
      {
        headers: new HttpHeaders().set(
          'Content-Type',
          'application/x-www-form-urlencoded'
        ),
      }
    );
  }
  deleteDirectory(form: UntypedFormGroup): Observable<Responses> {
    const body = new HttpParams().appendAll(form.value);
    return this.http.post<Responses>(
      this.domain + 'extensions/images/ddirectory/',
      body,
      {
        headers: new HttpHeaders().set(
          'Content-Type',
          'application/x-www-form-urlencoded'
        ),
      }
    );
  }
  updateDirectory(form: UntypedFormGroup): Observable<Responses> {
    const body = new HttpParams().appendAll(form.value);
    return this.http.post<Responses>(
      this.domain + 'extensions/images/dupdate/',
      body,
      {
        headers: new HttpHeaders().set(
          'Content-Type',
          'application/x-www-form-urlencoded'
        ),
      }
    );
  }
}

